import { render } from "./InspectionResult.vue?vue&type=template&id=5f832d2a"
import script from "./InspectionResult.vue?vue&type=script&lang=js"
export * from "./InspectionResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__